<template>
  <v-text-field ref="field" v-bind="$attrs" v-on="$listeners" :error-messages="errors"
    :messages="messages" :validate-on-blur="validateOnBlur" :autocomplete="autocomplete" aria-autocomplete="off"
 
    
    
    
    @focus="onFocus" 
    @blur="onBlur"  :error="error" :rules="[]"
    
    >



<!--     <template v-slot:prepend>

      <slot name="prepend-inner"/>

    </template> -->

  </v-text-field>


</template>

<script>
  /**
   * прозрачная обертка vuetify компонента VTextField, для подстарховки часто от поломки (в связи с апдейтами браузеров и пр.) используемых методов и имплементации уникального поведения
   */

  export default {
    /*     props: {
            attrs: Object
        } */

    inheritAttrs: false,
    data() {
      return {
        messages: '',
        /*    value: '', */
        errors: '',
        error: false
      }
    },
    watch: {
      value() {
        let res = this.validateField2()
        this.messages = res !== true ? res : ''
      }
    },
    computed: {
      rules() {
        return this.$attrs.rules
      },
      value() {
        return this.$attrs.value
      },
      autocomplete() {
        return this.$attrs.autocomplete || "off"
      },
      validateOnBlur() {
        return false//this.$attrs.validateOnBlur === false ? false : true
      }
    },
    methods: {


      onBlur() {
        this.messages = ''
        this.validate()
      },

      onFocus() {
        let res = this.validateField2()
        this.messages = res !== true ? res : ''
        this.error = false
        this.errors = ''
      },

      focus() {
        this.$refs.field.$refs.input.focus()
      },

      blur() {
        this.$refs.field.$refs.input.blur()
      },

      validate() {
        let res = this.validateField2()
        if (res !== true) {
          this.error = true
          this.errors = res
        }
        else
        {
          this.error = false
          this.errors = ''
        }
        return res === true
      },

      validateField2() {

        if (!this.rules || this.rules.length == 0) return

        for (let i = 0; i < this.rules.length; i++) {
          let rule = this.rules[i]
          let res = rule(this.value)

          if (res !== true) {
            return res
          }
        }
        
        return true
      },

      validateField() {

        if (!this.rules || this.rules.length == 0) return

        for (let i = 0; i < this.rules.length; i++) {
          let rule = this.rules[i]
          let res = rule(this.value)

          if (res != true) {
            return res
          }
        }

        return ''
      },


    }

  }
</script>

<style>
/** fix for android 4.2.2 чтобы префикс не уезжал вверх*/
.v-text-field__prefix {
  display: flex;
  align-items: center;
  height: 32px;
}
</style>